/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types -- needed */
import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from '@americanexpress/one-app-router';
import { useIntl } from 'react-intl';
import { Button, Link as DLSLink } from '@americanexpress/dls-react';
import { ExtendReactlytics } from '@americanexpress/reactlytics';
import BodySansCatalog from '../BodySansCatalog';
import LayoutContainerSansCatalog from '../LayoutContainerSansCatalog';
import EnrollStatus from '../enrollstatus/EnrollStatus';
import Tooltip from './disclaimer-tooltip';
import AnalyticsClick from '../../../../shared/components/analyticsClick';
import { layoutTypeResolver, ctaProtocolCheck } from '../utils';
import QuickViewPortalContainer from '../../../../shared/components/QuickViewPortalContainer';

const ViewAllTileSansCatalog = (props) => {
  const showMobileTileView = props?.showMobileTileView;
  const isListView = props?.isListView;
  const cardname = props?.cardname;
  const benefitNamesList = props?.benefitNamesList;
  const benefitsData = props?.benefitsData;

  const benefit = props?.benefit;
  const title = benefit?.title;

  const summary = benefit?.summary;
  const image = summary?.image;
  const copy = summary?.copy;
  const disclaimer = summary?.disclaimer;

  const showStatus = summary?.status?.enabled;
  const statusLabel = summary?.status?.label;
  const enrollmentApplicationStatus = summary?.status?.enrollmentApplication.status;

  const showLearnMore = summary?.learnMoreCTA?.enabled;
  const learnMoreLabel = summary?.learnMoreCTA?.label;
  const learnMoreHref = summary?.learnMoreCTA?.link;
  const productSelected = props?.productSelected;

  const showEnroll = summary?.enrollCTA.enabled;
  const enrollLabel = summary?.enrollCTA?.label;
  const enrollHref = summary?.enrollCTA?.link;

  const showExternal = summary?.externalCTA?.enabled;
  const externalLabel = summary?.externalCTA.label;
  const externalHref = ctaProtocolCheck(summary?.externalCTA?.link);

  const detail = benefit?.detail;
  const detailCopy = detail?.copy;
  const detailRequiresLogin = benefit?.detailRequiresLogin;

  const intl = useIntl(); // Hook for accessing locale content, intl.formatMessage()
  const locale = intl?.locale;
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;

  // To show quick view modal
  const [show, setShow] = React.useState(false);
  const toggleModal = () => setShow(!show);
  const detailPage = window.location.origin + learnMoreHref + productSelected;
  const mobileTileView = showMobileTileView || window.innerWidth < 768;

  const isDetailView = mobileTileView || locale !== 'en-US';

  const handleDetailPage = () => {
    if (learnMoreHref.startsWith('/card-benefits/detail')) {
      browserHistory.push(
        window.location.origin + learnMoreHref + productSelected
      );
    } else {
      window.location.assign(learnMoreHref);
    }
  };

  const handleEnrollPage = () => {
    if (enrollHref.startsWith('/card-benefits/enroll')) {
      browserHistory.push(window.location.origin + enrollHref);
    } else {
      window.location.assign(enrollHref);
    }
  };

  return (
    <LayoutContainerSansCatalog
      type={layoutTypeResolver(showMobileTileView, isListView)}
    >
      {global.BROWSER && (
        isDetailView ? (
          <AnalyticsClick onClick={handleDetailPage} element={`image>>${cardname?.replace(/ /g, '-').toLowerCase()}`} benefitNameTag={parseEntities(title)?.replace(/ /g, '-').toLowerCase()}>
            <img
              src={image}
              alt=""
              style={{ width: '100%', height: '160.8px', cursor: 'pointer' }}
              aria-hidden={true}
            />
          </AnalyticsClick>
        ) : (
          <AnalyticsClick onClick={toggleModal} element={`image>>${cardname?.replace(/ /g, '-').toLowerCase()}`} benefitNameTag={parseEntities(title)?.replace(/ /g, '-').toLowerCase()}>
            <img
              src={image}
              alt=""
              style={{ width: '100%', height: '160.8px', cursor: 'pointer' }}
              aria-hidden={true}
            />
          </AnalyticsClick>
        )
      )}
      <BodySansCatalog title={title} shortDescription={copy}>
        {showStatus && (
          <EnrollStatus
            label={statusLabel}
            enrollmentApplicationStatus={enrollmentApplicationStatus}
          />
        )}
      </BodySansCatalog>
      {disclaimer && (
        <Tooltip disclaimer={disclaimer} title={title} cardname={cardname} />
      )}
      {showEnroll && global.BROWSER && (
        <ExtendReactlytics
          analytics={{
            event: {
              meta: {
                benefitname: `${parseEntities(title)?.replace(/ /g, '-').toLowerCase()}`,
              },
            },
          }}
        >
          <Button
            onClick={handleEnrollPage}
            aria-label={parseEntities(`${`${intl.formatMessage({ id: enrollLabel })} ${title}`}`)}
            data-testid="enroll-link"
            reactlytics={{
              element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>pcta-enroll`,
              type: 'click',
            }}
            className="fluid"
            variant="secondary"
          >
            {enrollLabel}
          </Button>
        </ExtendReactlytics>
      )}
      {showExternal && (
        <AnalyticsClick
          element={`${cardname?.replace(/ /g, '-').toLowerCase()}>>pcta-enroll`}
          benefitNameTag={parseEntities(title)
            ?.replace(/ /g, '-')
            .toLowerCase()}
        >
          <DLSLink
            className="pad-0-tb"
            href={`${externalHref}`}
            rel="noreferrer"
            aria-label={parseEntities(
              `${`${intl.formatMessage({ id: 'view-all.card-benefits-tile.get-started' })} ${title}`}`
            )}
            data-testid="external-link"
          >
            {externalLabel}
          </DLSLink>
        </AnalyticsClick>
      )}
      {showLearnMore && global.BROWSER && (
        isDetailView
          ? (
            <ExtendReactlytics analytics={{ event: { meta: { benefitname: `${parseEntities(title)?.replace(/ /g, '-').toLowerCase()}` } } }}>
              <Button
                variant="tertiary"
                onClick={handleDetailPage}
                className="fluid"
                aria-label={parseEntities(`${`${learnMoreLabel} ${intl.formatMessage({ id: 'view-all.card-benefits-tile.about' })} ${title}`}`)}
                data-testid="learn-more-link"
                reactlytics={{ element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>scta-learn-more`, type: 'click' }}
              >
                {learnMoreLabel}
              </Button>
            </ExtendReactlytics>
          )
          : (
            <>
              <ExtendReactlytics analytics={{ event: { meta: { benefitname: `${parseEntities(title)?.replace(/ /g, '-').toLowerCase()}` } } }}>
                <Button
                  onClick={toggleModal}
                  variant="secondary"
                  className="fluid"
                  aria-label={parseEntities(`${`${learnMoreLabel} ${intl.formatMessage({ id: 'view-all.card-benefits-tile.about' })} ${title}`}`)}
                  data-testid="learn-more-quick-view"
                  reactlytics={{ element: `${cardname?.replace(/ /g, '-').toLowerCase()}>>quickview`, type: 'click' }}
                >
                  {learnMoreLabel}
                </Button>
              </ExtendReactlytics>
              {show && (
              <QuickViewPortalContainer
                toggleModal={toggleModal}
                closeButtonLabel="Close"
                dismissible={true}
                closeButtonProps=""
                modalDialogRef={null}
                cardname={cardname}
                name={benefit}
                title={title}
                copy={detailCopy}
                showStatus={showStatus}
                statusLabel={statusLabel}
                enrollmentApplicationStatus={enrollmentApplicationStatus}
                showEnroll={showEnroll}
                enrollLabel={enrollLabel}
                enrollHref={enrollHref}
                showExternal={showExternal}
                externalLabel={externalLabel}
                externalHref={externalHref}
                detailPage={detailPage}
                detailRequiresLogin={detailRequiresLogin}
                benefitNamesList={benefitNamesList}
                benefitsData={benefitsData}
                productSelected={productSelected}
              />
              )}
            </>
          )
      )}
    </LayoutContainerSansCatalog>
  );
};

ViewAllTileSansCatalog.propTypes = {
  benefit: PropTypes.string,
  cardname: PropTypes.string,
  showMobileTileView: PropTypes.bool,
  isListView: PropTypes.bool,
  productSelected: PropTypes.string,
  benefitNamesList: PropTypes.string,
  benefitsData: PropTypes.string,
};

export const ComponentUnderTest = ViewAllTileSansCatalog;
export default ViewAllTileSansCatalog;
